import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/additionalInformation/factoryCode`;

interface SetAdditionalInformationFactoryCodePayload {
  capture: File;
  fileId: string;
}

const setAdditionalInformationFactoryCode = async ({
  capture,
  fileId,
}: SetAdditionalInformationFactoryCodePayload): Promise<
  BackResponse<string> | BackResponseFailure
> => {
  try {
    const body = new FormData();

    if (capture) {
      body.append('File', capture);
    }

    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

    const response = await apiCall<BackResponse<string>>(url, {
      method: SUPPORTED_METHODS.POST,
      body,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default setAdditionalInformationFactoryCode;
